import { Card } from "@/components/ui/card";
import {
  BooleanField,
  DataTable,
  List,
  ListActions,
  NeutralBadge,
  NumberField,
  SearchInput,
} from "../../common";

const filters = [<SearchInput key="q" source="q" alwaysOn />];

export const PayrollComponentList = () => (
  <List
    title="Payroll Components"
    filters={filters}
    actions={<ListActions label="Add Component" />}
    sort={{ field: "sort_order", order: "ASC" }}
  >
    <Card className="border border-border rounded-xl bg-card shadow-sm overflow-hidden">
      <DataTable rowClick="edit">
        <DataTable.Col source="code" label="Code" className="font-mono text-xs bg-muted px-2 py-0.5 rounded border" />
        <DataTable.Col source="name" label="Name" className="font-semibold" />
        <DataTable.Col label="Type">
          <NeutralBadge source="type" />
        </DataTable.Col>
        <DataTable.Col label="Calculation">
          <NeutralBadge source="calculation" />
        </DataTable.Col>
        <DataTable.Col source="value" label="Value">
          <NumberField source="value" />
        </DataTable.Col>
        <DataTable.Col source="taxable" label="Taxable">
          <BooleanField source="taxable" />
        </DataTable.Col>
      </DataTable>
    </Card>
  </List>
);

